import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { LoaderCircle, ArrowLeft } from "lucide-react";
import { apiCall } from "../Apis/apiCall";
import LoadingComponent from "./ui/LoadingComponent";

const ClientByID = () => {
  const { clientId } = useParams();
  const navigate = useNavigate();
  const [selectedClient, setSelectedClient] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const getClientLogo = (url) => {
    // if (!url) return "/Uploads/client_logos/";
    return `https://pevbackend.codovio.com/public/${url}`;
  };

  useEffect(() => {
    const fetchClient = async () => {
      setIsLoading(true);
      try {
        const response = await apiCall(
          "get",
          `/get-client-by-id/${clientId}`,
          null,
          navigate
        );
        setSelectedClient(response.data.data);
      } catch (err) {
        setError("Failed to fetch client data");
        console.error(err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchClient();
  }, []);

  if (isLoading) {
    return <LoadingComponent />;
  }

  if (error || !selectedClient) {
    return (
      <div className="container mt-5">
        <div
          className="alert alert-danger d-flex align-items-center gap-2"
          role="alert"
        >
          <svg
            className="bi flex-shrink-0 me-2"
            width="24"
            height="24"
            role="img"
            aria-label="Danger:"
          >
            <use xlinkHref="#exclamation-triangle-fill" />
          </svg>
          <div>{error || "No client data found"}</div>
        </div>
        <button
          className="btn btn-outline-secondary d-flex align-items-center gap-2"
          onClick={() => navigate(-1)}
        >
          <ArrowLeft size={20} />
          Back
        </button>
      </div>
    );
  }

  return (
    <div class="container min-vh-100 d-flex justify-content-center align-items-center">
      <div class="col-2"></div>
      <div class="col">
        <div class="">
          <div class="user-grid-card position-relative border rounded-4 overflow-hidden bg-light h-100 p-5">
            {/* <img
              src="https://dummyjson.com/image/200x100"
              alt="WowDash React Vite"
              class="w-100 object-fit-cover"
            /> */}
            <div class="pb-4 ps-4 pe-4 pt-0 mt-n5">
              <div class="text-center border-bottom pb-3">
                <img
                  src="https://avatar.iran.liara.run/public/3"
                  alt="user img"
                  class="border border-white border-2 rounded-circle object-fit-cover"
                  // styleName={{ width: "10px", height: "10px" }}
                  sizes="24"
                  width={100}
                />
                <h6 class="mb-0 mt-3">
                  {selectedClient.client_name.toUpperCase() || "N/A"}
                </h6>
                <span class="text-secondary d-block mb-3">
                  {selectedClient.email || "N/A"}{" "}
                </span>
              </div>
              <div class="mt-4">
                <h6 class="fs-5 mb-3">Personal Info</h6>
                <ul class="list-unstyled">
                  <li class="d-flex align-items-center gap-2 mb-2">
                    <span class="w-30 fw-semibold text-primary">Full Name</span>
                    <span class="text-secondary">
                      : {selectedClient.client_name || "N/A"}
                    </span>
                  </li>
                  <li class="d-flex align-items-center gap-2 mb-2">
                    <span class="w-30 fw-semibold text-primary">Email</span>
                    <span class="text-secondary">
                      : {selectedClient.email || "N/A"}
                    </span>
                  </li>
                  <li class="d-flex align-items-center gap-2 mb-2">
                    <span class="w-30 fw-semibold text-primary">
                      Phone Number
                    </span>
                    <span class="text-secondary">
                      : {selectedClient.phone_no || "N/A"}
                    </span>
                  </li>
                  <li class="d-flex align-items-center gap-2 mb-2">
                    <span class="w-30 fw-semibold text-primary">Type</span>
                    <span class="text-secondary">
                      : {selectedClient.client_type || "N/A"}
                    </span>
                  </li>
                  <li class="d-flex align-items-center gap-2 mb-2">
                    <span class="w-30 fw-semibold text-primary">Plan</span>
                    <span class="text-secondary">
                      : {selectedClient.plan_name || "N/A"}
                    </span>
                  </li>
                  <li class="d-flex align-items-center gap-2 mb-2">
                    <span class="w-30 fw-semibold text-primary">Status</span>
                    <span class="text-secondary">
                      : {selectedClient.is_active ? "Active" : "Inactive"}
                    </span>
                  </li>
                  <li class="d-flex align-items-center gap-2 mb-2">
                    <span class="w-30 fw-semibold text-primary">
                      Created By
                    </span>
                    <span class="text-secondary">
                      : {selectedClient.created_by.toUpperCase() || "N/A"}
                    </span>
                  </li>
                  <li class="d-flex align-items-center gap-2 mb-2">
                    <span class="w-30 fw-semibold text-primary">
                      Created Date
                    </span>
                    <span class="text-secondary">
                      :{" "}
                      {new Date(
                        selectedClient.created_datetime
                      ).toLocaleDateString("en-GB", {
                        day: "2-digit",
                        month: "2-digit",
                        year: "numeric",
                      })}
                    </span>
                  </li>
                  <li class="d-flex align-items-center gap-2 mb-2">
                    <span class="w-30 fw-semibold text-primary">
                      Trial Start
                    </span>
                    <span class="text-secondary">
                      :{" "}
                      {new Date(
                        selectedClient.trial_start_date
                      ).toLocaleDateString("en-GB", {
                        day: "2-digit",
                        month: "2-digit",
                        year: "numeric",
                      })}
                    </span>
                  </li>
                  <li class="d-flex align-items-center gap-2 mb-2">
                    <span class="w-30 fw-semibold text-primary">Trial End</span>
                    <span class="text-secondary">
                      :{" "}
                      {new Date(
                        selectedClient.trial_end_date
                      ).toLocaleDateString("en-GB", {
                        day: "2-digit",
                        month: "2-digit",
                        year: "numeric",
                      })}
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClientByID;